import callNative from '@iqiyi-kpp/callnative'

export default {
  install(Vue) {
    Vue.prototype.$callNative = callNative
  }
}
